import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MainContext } from "../../components/context/context";

import { motion } from "framer-motion";

import "./HallScene.scss";

// Assets
import floor from "../../assets/media/Home/FloorBull.png"

import column from "../../assets/media/Home/CollumnBull.png"
import statue from "../../assets/media/Home/StatuesBull.png"
import stairs from "../../assets/media/Home/StairsBull.png"
import Torchlights from "../../assets/media/Intro/Hall/Torches-Left (2).gif";
import Torchlights1 from "../../assets/media/Intro/Hall/Torches-Right (2).gif";
import LogoMain from "../../assets/media/images/bearbull.png";
import HallFrame from "../../assets/media/images/Bull-Popup-Home.png";
import HallFrameLocked from "../../assets/media/images/Bull-Popup.png";
import TwitterPixel from "../../assets/media/icons/TwitterPixel.png";
import DiscordPixel from "../../assets/media/icons/DiscordPixel.png";


import AnubisDark from "../../assets/media/Intro/Hall/Treasurer-D_scaled_2x_minified.gif";
import AnubisHover from "../../assets/media/Intro/Hall/Treasurer-H_scaled_2x_minified.gif";
import KingDark from "../../assets/media/Intro/Hall/BullKing_scaled_2x_minified.gif";
import KingHover from "../../assets/media/Intro/Hall/BullKing-H_scaled_2x_minified.gif";
import LichDark from "../../assets/media/Intro/Hall/Death-D_scaled_2x_minified.gif";
import LichHover from "../../assets/media/Intro/Hall/Death-H_scaled_2x_minified.gif";

import SageDark from "../../assets/media/Intro/Hall/AdvisorP-D_scaled_2x_minified (1).gif";
import SageHover from "../../assets/media/Intro/Hall/AdvisorP-H_scaled_2x_minified.gif";

import BullDark from "../../assets/media/Intro/Hall/Samurai-D_scaled_2x_minified.gif";
import BullHover from "../../assets/media/Intro/Hall/Samurai-H_scaled_2x_minified.gif";
import NavBar from "../../components/NavBar/NavBar";
const BullScene = () => {
  const navigate = useNavigate();
  const { setShowNavBar, isSoundEnabled, setIsSoundEnabled } =
    useContext(MainContext);

  // Navigating states
  const [navigatingHome, setNavigatingHome] = useState(false);
  const [navigatingWLChecker, setNavigatingWLChecker] = useState(false);
  const [navigatingWhitepaper, setNavigatingWhitepaper] = useState(false);
  const [navigatingMarketplace, setNavigatingMarketplace] = useState(false);
  const [navigatingTOS, setNavigatingTOS] = useState(false);
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  useEffect(() => {
    const assetUrls = [
      floor, column, statue, stairs, Torchlights, Torchlights1, LogoMain, HallFrame, HallFrameLocked,
      TwitterPixel, DiscordPixel, AnubisDark, AnubisHover, KingDark, KingHover,
      LichDark, LichHover, SageDark, SageHover, BullDark, BullHover
    ];
  
    const loadImage = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = resolve; // Don't block if error
      });
  
    Promise.all(assetUrls.map(loadImage)).then(() => {
      setAssetsLoaded(true);
    });
  }, []);
  
  useEffect(() => {
    document.title = "Fortune Foes | Bulls Hall";

    setShowNavBar(false);
    document.body.style.height = "100%";
    document.body.style.overflow = "hidden";
  }, [setShowNavBar]);

  // Blocking the context menu
  const blockContextMenu = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    document.addEventListener("contextmenu", blockContextMenu);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu);
    };
  }, []);

  const handleNavigate = (path) => {
    // check the path and give the correct animation with switch case
    switch (path) {
      case "/home":
        setNavigatingHome(true);
        setNavigatingWLChecker(false);
        setNavigatingWhitepaper(false);
        setNavigatingMarketplace(false);
        setNavigatingTOS(false);
        break;

      case "/theallowlist":
        setNavigatingHome(false);
        setNavigatingWLChecker(true);
        setNavigatingWhitepaper(false);
        setNavigatingMarketplace(false);
        setNavigatingTOS(false);
        break;

      case "/whitepaper":
        setNavigatingHome(false);
        setNavigatingWLChecker(false);
        setNavigatingWhitepaper(true);
        setNavigatingMarketplace(false);
        setNavigatingTOS(false);
        break;

      case "/marketplace":
        setNavigatingHome(false);
        setNavigatingWLChecker(false);
        setNavigatingWhitepaper(false);
        setNavigatingMarketplace(true);
        setNavigatingTOS(false);
        break;

      case "/tos":
        setNavigatingHome(false);
        setNavigatingWLChecker(false);
        setNavigatingWhitepaper(false);
        setNavigatingMarketplace(false);
        setNavigatingTOS(true);
        break;

      default:
        break;
    }

    navigate(path);
  };

  // Determine the path to go and shape the exit animation. It will leave the clicked bear normal and make the other bears transparent

  const exitAnimation = (path) => {
    let opacity = 0;

    switch (path) {
      case "/home":
        opacity = navigatingHome ? 1 : 0;
        break;
      case "/theallowlist":
        opacity = navigatingWLChecker ? 1 : 0;
        break;
      case "/whitepaper":
        opacity = navigatingWhitepaper ? 1 : 0;
        break;
      case "/marketplace":
        opacity = navigatingMarketplace ? 1 : 0;
        break;
      case "/tos":
        opacity = navigatingTOS ? 1 : 0;
        break;
      default:
        opacity = 0;
        break;
    }

    return { opacity };
  };

  return (
    <>
    {!assetsLoaded ?     <div
    className={
      assetsLoaded
        ? "initial-loading-wrapper hide"
        : "initial-loading-wrapper"
    }
  >    <img
  draggable="false"
  className="initial-loading-gif"
  src="/assets/loading.gif"
  alt="loading"
/></div> :   <motion.div
       initial={{ opacity: 0 }}
  animate={{ opacity: 1, transition: { duration: 0.4, ease: "easeOut" } }}
  


       

        >  
    <div className="hall-scene">
    <NavBar />
      <div className="hall-background1" />
 

      {/* Mobile hall links */}
      <div className="mobile-hall-links">
        <Link to="/home">HOME</Link>
        {/* <Link to="/holders-dash">HOLDERS DASH</Link> */}
        {/* <Link to="/mint">MINT</Link> */}
      </div>
      {/* Mobile hall links end */}

      <motion.div

          style={{width:"100%", position:"absolute"}} 

        >
  
       
            <img style={{width:"100%"}} src={column} alt=""/>
         

        </motion.div>

   
      <div className="bottom-wrapper">

      <div className="torchlights-wrapper2">
      <motion.div
    

        >
  
       
            <img  src={statue} alt=""/>
         

        </motion.div>
  
        
        
        </div>
        <div className="bears-container1">
        <motion.div
     
          transition={{ ease: "easeOut", duration: 1.5 }}
          className="king-bear-wrapper"
        >
          <div className="mint-auction">
            <img src={HallFrame} className="hall-frame" alt="" />
            <div className="mint-auction-text">HOMEPAGE</div>
          </div>

          <div
            onClick={() => handleNavigate("/")}
            className="king-bear-video hall-bear"
          >
            <img playsInline loop muted autoPlay src={KingDark} alt="king"/>
            <img
              className="king-hover"
              playsInline
              loop
              muted
              autoPlay
              src={KingHover}
              alt="king"
            />
          </div>
        </motion.div>
        <motion.div

// exit={exitAnimation}
transition={{ ease: "easeOut", duration: 1.5 }}
className="lich-bear-wrapper1"
>
<div className="lich-glow" />
<div className="loss-calculator">
  <img src={HallFrameLocked} className="hall-frame" alt="" />
  <div className="loss-calculator-text">ISLANDS</div>
</div>
<div
  // onClick={() => navigate("/whitelist-quests")}
  className="lich-bear-video hall-bear"
>
  <img playsInline loop muted autoPlay src={LichDark} alt=""/>
  <img
    className="lich-hover"
    playsInline
    loop
    muted
    autoPlay
    src={LichHover}
    alt=""
  />
</div>
</motion.div>       
 <motion.div

className="lich-bear-wrapper3"
>
<div className="lich-glow" />
<div className="loss-calculator">
  <img src={HallFrameLocked} className="hall-frame" alt="" />
  <div className="loss-calculator-text">$𐂂𐂀𓂀⸮𓆣</div>
</div>
<div
  // onClick={() => navigate("/whitelist-quests")}
  className="lich-bear-video hall-bear"
>
  <img playsInline loop muted autoPlay src={AnubisDark} alt=""/>
  <img
    className="lich-hover"
    playsInline
    loop
    muted
    autoPlay
    src={AnubisHover}
    alt=""
  />
</div>
</motion.div>


<motion.div

transition={{ ease: "easeOut", duration: 1.5 }}
className="cowboy-bear-wrapper1"
>
<div className="cowboy-glow" />
<div className="eth-trader">
  <img src={HallFrameLocked} className="hall-frame" alt="" />
  <div className="eth-trader-text">ARMY</div>
</div>
<div
  // onClick={() => window.open("https://sim.barbearians.xyz", "_blank")}
  className="cowboy-bear-video hall-bear locked"
>
  <img playsInline loop muted autoPlay src={SageDark} alt="" />
  <img
    className="cowboy-hover"
    playsInline
    loop
    muted
    autoPlay
    src={SageHover}
    alt=""
  />
</div>
</motion.div>

<motion.div

className="bull-bear-wrapper1"
>
<div className="bull-glow" />
<div className="hall-whitepaper-text">
  <img src={HallFrameLocked} className="hall-frame" alt="" />
  <div className="hall-whitepaper-text">CLASH</div>
</div>
<div
  // onClick={() => handleNavigate("/whitepaper")}
  className="bull-bear-video hall-bear locked"
>
  <img playsInline loop muted autoPlay src={BullDark} alt=""/>
  <img
    className="bull-hover"
    playsInline
    loop
    muted
    autoPlay
    src={BullHover}
    alt=""
  />
</div>
</motion.div>

      </div> 
      <div className="torchlights-wrapper2">
        
      <motion.div
  

        >
  
       
            <img  src={stairs} alt=""/>
         

        </motion.div></div>
        
      <div className="torchlights-wrapper1">
      <motion.div
   

        >
  
       
            <img  src={floor} alt=""/>
         

        </motion.div></div>
  
      </div>

      <div className="torchlights-wrapper">

        <motion.img

          src={Torchlights}
          className="torchlights-one"
          alt=""
        />
        <motion.img
  
          src={Torchlights1}
          className="torchlights-one"
          alt=""
        />
      </div>
  
    
    </div></motion.div>}</>
  );
};

export default BullScene;
